import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';
import AuthButton from './AuthButton';

export default function AuthProgressButton(props) {
    const { children, loading, ...restProps } = props;

    const loadIcon = loading && <CircularProgress color="inherit" variant="indeterminate" size={16} />;

    return (
        <AuthButton startIcon={loadIcon} disabled={loading} {...restProps}>
            {children}
        </AuthButton>
    );
}

AuthProgressButton.propTypes = {
    ...AuthButton.propTypes,

    loading: PropTypes.bool,
};

AuthProgressButton.defaultProps = {
    ...AuthButton.defaultProps,

    loading: false,
};
